import Vue from 'vue'

export default (data) => {
    if (process.env.NODE_ENV === "development") {
        return new Promise(resolve => {
            resolve({
                data: "ru:Русский|ua:Український|en:English"
            })
        })
    } else {
        return Vue.Api.Get(data.API_ORIGIN + data.PATH + '/Language/GetLanguagesList?_=' + data.date);
    }
};
